import { render } from "./Chat.vue?vue&type=template&id=6908d81f"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\sander\\IdeaProjects\\matchmaking\\fbm-matchmaking\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__